import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	Button,
} from '@mui/material';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import styles from './DocumentationHistoryTable.module.scss';
import { openModal, closeModal } from '../../../../../redux/modals/action';
import AddDocumentModal from '../../AddDocumentModal/AddDocumentModal';
import DocumentItem from './DocumentItem';
import { TableRow } from '@material-ui/core';
import getDocumentStatusByDocumentName from '../../../../../api/Purchasers/getDocumentStatus.api';
import * as DOCUMENT_NAME from '../../../../../constants/documentNames';
import Client from '../../../../document/client/Client';
import {
	setConfirmation,
	closeConfirmation,
} from '../../../../../redux/confirmations/actions';
import Confirmation from '../../../../confirmation/ConfirmationComponent';
import { cancelForm } from '../../../../../api/Purchasers/cancelDocuments.api';
import * as ORIGINAL_HREF from '../../../../../constants/originalHref';
import { setAlert } from '../../../../../redux/alerts/action';
import AddIcon from '@mui/icons-material/Add';

const DocumentationHistoryTable = ({
	handleOpenAddDocument,
	client,
	documentStatus,
	documentExtras,
	agreementById,
	setConfirmation,
	closeConfirmation,
	confirmation,
	documentTarget,
	closeModal,
	setAlert,
}) => {
	const [APSLatestStatus, setAPSLatestStatus] = useState();
	const [condoDocsLatestStatus, setCondoDocsLatestStatus] = useState();
	const columns = [
		{ field: 'document', headerName: 'Document' },
		{ field: 'creationDate', headerName: 'Creation Date' },
		{ field: 'status', headerName: 'Status' },
		{ field: 'files', headerName: 'Files' },
	];
	const [extraDocLatestStatus, setExtraDocLatestStatus] = useState([]);
	const [documentInformation, setDocumentInformation] = useState();

	console.log('wdiofjwoifwf', documentStatus);

	var buttonList = [
		{
			name: 'Discard',
			action: () => {
				handleCloseConfirmation();
			},
			style: {
				color: 'var(--primary)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Delete Document',
			action: () => {
				handleCancelDocument();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--error)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
	];

	useEffect(() => {
		getDocumentStatusByDocumentName(
			client?.leadId,
			DOCUMENT_NAME.aps,
			(returned) => {
				setAPSLatestStatus(returned);
				console.log('returned aps', returned);
			}
		);
		getDocumentStatusByDocumentName(
			client?.leadId,
			DOCUMENT_NAME.condo_docs,
			(returned) => {
				setCondoDocsLatestStatus(returned);
				console.log('returned condo docs', returned);
			}
		);

		console.log('document extras doc', documentExtras);

		var documentExtrasKeys = documentExtras && Object.keys(documentExtras);

		var subjectNameArr = [];

		documentExtrasKeys?.map((key) => {
			var subjectName = documentExtras[key]['subject'];
			subjectNameArr.push(subjectName);
		});

		var uniqueSubject = [...new Set(subjectNameArr)];

		console.log('uniqueSubject', uniqueSubject);

		var extraDocLatestStatusArr = [];

		uniqueSubject?.map((key) => {
			var subjectName = key;

			console.log('documentExtrasKeys subjectName', key);

			getDocumentStatusByDocumentName(
				client?.leadId,
				subjectName,
				(returned) => {
					extraDocLatestStatusArr.push(returned);
					console.log('returned extra docs', returned);
				}
			);
		});

		console.log('extraDocLatestStatusArr', extraDocLatestStatusArr);

		setExtraDocLatestStatus(extraDocLatestStatusArr);
	}, [client, documentExtras]);

	console.log('DocumentationHistoryTable client', client);

	const handleDeleteDocument = (latestStatus) => {
		setConfirmation('deleteDocument');
		console.log('handleDeleteDocument', latestStatus);
		setDocumentInformation(latestStatus);
	};

	// confirmation
	const handleCloseConfirmation = () => {
		closeConfirmation('deleteDocument');
	};

	useEffect(() => {
		console.log('docuemnt inf asfow f', documentInformation);
	}, [documentInformation]);

	const handleCancelDocument = () => {
		var doc;

		console.log('handleCancelDocument documentTarget', documentTarget);

		if (documentTarget?.documentName === 'APS') {
			doc = DOCUMENT_NAME.aps;
		} else if (documentTarget?.documentName === 'Condo Docs') {
			doc = DOCUMENT_NAME.condo_docs;
		} else {
			doc = documentTarget?.documentName;
		}

		console.log('handleCancelDocument docccccc', doc);
		closeConfirmation('deleteDocument');
		closeModal('clientDetails');

		cancelForm(
			client?.lotId,
			client?.leadId,
			ORIGINAL_HREF.originalHREF['access_token'],
			doc,
			(returned) => {
				console.log('returneddd', returned);
				setAlert(returned.alertType, returned.message);
			}
		);
	};

	useEffect(() => {
		console.log('documentTargetdocumentTarget', documentTarget);
	}, [documentTarget]);

	return (
		<>
			<TableContainer>
				<Table className={styles.table}>
					<TableHead>
						{columns.map((column) => (
							<TableCell
								itemID={column.field}
								align={'left'}
								className={styles.tableCell}
								style={{ borderBottom: 'none' }}
							>
								{column.headerName}
							</TableCell>
						))}
					</TableHead>
					<TableBody>
						{APSLatestStatus ? (
							documentStatus === 'ready' ? (
								<DocumentItem
									client={client}
									latestStatus={{
										documentName: 'APS',
										status: 'not_sent',
										extras: [
											{
												signerRole: 'Client',
												statusCode: 'not_sent',
												color: '',
											},
											{
												role: 'Builder',
												statusCode: 'not_sent',
												color: '',
											},
										],
									}}
									agreementById={agreementById}
									handleDeleteDocument={handleDeleteDocument}
									setDocumentInformation={
										setDocumentInformation
									}
								/>
							) : (
								<DocumentItem
									client={client}
									latestStatus={APSLatestStatus}
									agreementById={agreementById}
									handleDeleteDocument={handleDeleteDocument}
									setDocumentInformation={
										setDocumentInformation
									}
								/>
							)
						) : (
							<DocumentItem
								client={client}
								latestStatus={{
									documentName: 'APS',
									status: 'not_sent',
									extras: [
										{
											signerRole: 'Client',
											statusCode: 'not_sent',
											color: '',
										},
										{
											role: 'Builder',
											statusCode: 'not_sent',
											color: '',
										},
									],
								}}
								agreementById={agreementById}
								handleDeleteDocument={handleDeleteDocument}
								setDocumentInformation={setDocumentInformation}
							/>
						)}
						<DocumentItem
							client={client}
							latestStatus={condoDocsLatestStatus}
							agreementById={agreementById}
							handleDeleteDocument={handleDeleteDocument}
							setDocumentInformation={setDocumentInformation}
						/>
						{extraDocLatestStatus?.map((document) => (
							<DocumentItem
								client={client}
								latestStatus={document}
								agreementById={agreementById}
								handleDeleteDocument={handleDeleteDocument}
								setDocumentInformation={setDocumentInformation}
							/>
						))}
					</TableBody>
				</Table>
				<Button
					startIcon={<AddIcon />}
					className={`${styles.add_doc_btn} ${
						documentStatus !== 'sent' &&
						documentStatus !== 'cancelled' &&
						styles.disable
					}`}
					disabled={
						documentStatus !== 'sent' &&
						documentStatus !== 'cancelled'
					}
					onClick={() => {
						(documentStatus === 'sent' ||
							documentStatus === 'cancelled') &&
							handleOpenAddDocument(APSLatestStatus?.eventType);
					}}
				>
					Add Document
				</Button>
			</TableContainer>

			<Confirmation
				open={confirmation?.deleteDocument}
				handleClose={handleCloseConfirmation}
				title={confirmation['confirmationDetails']['title']}
				dialogContent={confirmation['confirmationDetails']['message']}
				buttonList={buttonList}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	documentStatus:
		state.agreement.agreementById?.documentInformation?.documentStatus,
	documentExtras:
		state.agreement.agreementById?.documentInformation
			?.signatureRequestsExtras,
	agreementById: state.agreement?.agreementById,
	confirmation: state.confirmation,
	documentTarget: state.purchasers.documentTarget,
});

export default connect(mapStateToProps, {
	setConfirmation,
	closeConfirmation,
	closeModal,
	setAlert,
})(DocumentationHistoryTable);
